import { lazy } from 'react'

export const ReleaseDetailPage = lazy(() => import('./ReleaseDetailPage'))
